module.exports = __webpack_public_path__ + "static/media/quotegreen1.e54e23c6.png";